import React, { useState, useEffect } from 'react';
import axios from 'axios';

import '../../../css/popup.css';
import * as Icons from '../../../images/icons/icons_component'
import * as Theme from '../../../images/icons/icons_theme';

const TrmsV2_popup = () => {

    const [data, setData] = useState({});

    const popupData = async (sendData) => {
        try {
            const response = await axios.get('/trmsapi/oesangweb/bdtrms_detail_v2.do', {
                params: sendData
            });
            setData(response.data || {});
        } catch (e) {
            console.error('❌ 팝업 데이터 로딩 오류', e);
        }
    };

    useEffect(() => {
        const storedData = localStorage.getItem('trmsData');
        if (storedData) {
            const sendData = JSON.parse(storedData);
            popupData(sendData);
        }
    }, []);

    // 구조 분해 및 기본값 할당으로 undefined 방지
    const {
        detail = [],
        pgynlist = [],
        paynlist = [],
        preslist = [],
        resplist = [],
        vbralist = [],
        voxalist = [],
        emihsdmdlist = [],
        emihcltplist = [],
        emihdgotlist = [],
        emihdgdclist = [],
        emihdgdtlist = [],
        emihaisilist1 = [],
        emihaisilist2 = [],
        emihaisilist3 = [],
        emihaisilist4 = [],
        emihaisilist5 = [],
        emihaisilist6 = [],
        emihtrhtlist1 = [],
        emihtrhtlist2 = [],
        emihtrhtlist3 = [],
        emihtrhtlist4 = [],
    } = data;

    return (
        <div className='popup_container'>
            <div className='btn_container flex justify-between'>
                <div>
                    <div className='flex items-center bold'>
                        <Theme.Dot16 className='tr_non' />
                        <span className='ml-1'>어두운 색 항목은 미 전송 처리된 항목입니다.</span>
                    </div>
                    <div className='flex items-center bold'>
                        <Theme.Dot16 className='tr_row' />
                        <span className='ml-1'>밝은 색 항목은 NEDIS 연동 데이터 입니다.<span className='ml-2 co_red'>수정을 원하시면 NEDIS 데이터 입력 담당자</span>에게 문의하십시오.</span>
                    </div>
                </div>
                <button onClick={() => window.close()} className='comm_btn bg_co_black'>닫기</button>
            </div>
            <div className='popup_title'>
                <table summary='자료상태값'>
                    <colgroup>
                        <col width='12%' />
                        <col width='12%' />
                        <col width='12%' />
                        <col width='12%' />
                        <col width='12%' />
                        <col width='12%' />
                        <col width='12%' />
                        <col width='12%' />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>자료처리상태</th>
                            <td>{detail?.TRMSSTAT}</td>
                            <th>전송일시</th>
                            <td>{detail?.TRMSWKDTM}</td>
                            <th>표준등록체계상태</th>
                            <td>{detail?.PTMISTAT}</td>
                            <th>외상제외대상여부</th>
                            <td>{detail?.TRMSEXYN || '-'}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='trms_v_container'>
                <div className='trms_v_wrapper'>
                    <div className='trms_v_section'>
                        <div className='trms_v_subject'>&nbsp;1. 환자 상세 조회</div>
                        <table summary='의료기관 정보'>
                            <colgroup>
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='nedis'>의료기관명</th>
                                    <td>{detail?.EMOGDESC}</td>
                                    <th className='nedis'>요양기관번호</th>
                                    <td>{detail?.PTMIHSCD}</td>
                                    <th className='nedis'>응급의료기관코드</th>
                                    <td>{detail?.TRMSEMCD}</td>
                                </tr>
                                <tr>
                                    <th className='nedis'>의무기록번호</th>
                                    <td>{detail?.PTMIMASK}</td>
                                    <th className='nedis'>주된 진료를 받은 응급의료센터</th>
                                    <td>{detail?.PTMIMDCD}</td>
                                    <th>환자분류</th>
                                    <td>{detail?.TRMSPTGB}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;2. 인구통계학적 정보</div>
                        <table summary='인구통계학적 정보'>
                            <colgroup>
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='nedis'>성명</th>
                                    <td>{detail?.PTMINAME}</td>
                                    <th className='nedis'>연령</th>
                                    <td>{detail?.PTMIBRTD}</td>
                                    <th className='nedis'>성별</th>
                                    <td>{detail?.PTMISEXX}</td>
                                </tr>
                                <tr>
                                    <th>환자국적</th>
                                    <td>{detail?.TRMSNATN} {detail?.TRMSNATX}</td>
                                    <th>거주지역</th>
                                    <td colspan='3'>{detail?.TRMSADR1} {detail?.TRMSADR2} {detail?.TRMSADR3}</td>
                                </tr>
                                <tr>
                                    <th>미거주자</th>
                                    <td colspan='5'>{detail?.TRMSNORE}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;3. 손상관련 정보</div>
                        <table summary='손상 관련 정보'>
                            <colgroup>
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='nedis'>질병여부</th>
                                    <td>{detail?.PTMIDGKD}</td>
                                    <th className='nedis'>의도성여부</th>
                                    <td>{detail?.PTMIARCF}</td>
                                    <th>손상유형</th>
                                    <td>{detail?.TRMSDMTP} ({detail?.TRMSDMTX})</td>
                                </tr>
                                <tr>
                                    <th>사고종류</th>
                                    <td colspan='5'>
                                        {detail?.TRMSACKN} <span>추락높이:({detail?.TRMSACFL})m</span> 기타사유:({detail?.TRMSACTX})
                                    </td>
                                </tr>
                                <tr>
                                    <th rowspan='2'>보호장구</th>
                                    <td colSpan={5}>
                                        {pgynlist && pgynlist.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmspgyn'
                                                    id={`trmspgyn${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSPGYN === item.bscdminr}
                                                />
                                                <label htmlFor={`trmspgyn${index + 1}`}>{item.bscddesc}</label>
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={5}>
                                        <input
                                            type='checkbox'
                                            name='trmspg01'
                                            id='trmspg01'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG01 === 'Y'}
                                        />
                                        <label htmlFor='trmspg01'>안전벨트</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg02'
                                            id='trmspg02'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG02 === 'Y'}
                                        />
                                        <label htmlFor='trmspg02'>구명조끼</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg03'
                                            id='trmspg03'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG03 === 'Y'}
                                        />
                                        <label htmlFor='trmspg03'>헬멧</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg04'
                                            id='trmspg04'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG04 === 'Y'}
                                        />
                                        <label htmlFor='trmspg04'>고글</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg05'
                                            id='trmspg05'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG05 === 'Y'}
                                        />
                                        <label htmlFor='trmspg05'>카시트</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg06'
                                            id='trmspg06'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG06 === 'Y'}
                                        />
                                        <label htmlFor='trmspg06'>에어백</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg07'
                                            id='trmspg07'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG07 === 'Y'}
                                        />
                                        <label htmlFor='trmspg07'>무릎 및 관절 보호대</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg09'
                                            id='trmspg09'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG09 === 'Y'}
                                        />
                                        <label htmlFor='trmspg09'>미상</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg08'
                                            id='trmspg08'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG08 === 'Y'}
                                        />
                                        <label htmlFor='trmspg08'>기타 {detail?.TRMSPGTX}</label>
                                    </td>
                                </tr>
                                <tr>
                                    <th>교통사고 손상 당사자</th>
                                    <td>{detail?.TRMSTAIP}</td>
                                    <th>교통사고 시 <br />상대방 이송수단</th>
                                    <td colspan='3'>{detail?.TRMSTAIO}</td>
                                </tr>
                                <tr>
                                    <th>직업관련</th>
                                    <td colspan='3'>
                                        {paynlist.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmspayn'
                                                    id={`trmspayn${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSPAYN === item.bscdminr}
                                                />
                                                <label htmlFor={`trmspayn${index + 1}`}>{item.bscddesc}</label>
                                            </React.Fragment>
                                        ))}
                                    </td>
                                    <th>직업</th>
                                    <td>{detail?.TRMSOCCU} {detail?.TRMSOCTX}</td>
                                </tr>
                                <tr>
                                    <th>손상발생일시</th>
                                    <td>{detail?.TRMSHUDTM}</td>
                                    <th>손상발생일시 미상여부</th>
                                    <td>{detail?.TRMSHUUK}</td>
                                    <th>주증상 발생일시</th>
                                    <td>{detail?.TRMSMNDTM}</td>
                                </tr>
                                <tr>
                                    <th>사고발생지역</th>
                                    <td>{detail?.TRMSACA1} {detail?.TRMSACA2} {detail?.TRMSACA3}</td>
                                    <th>사고발생장소</th>
                                    <td colspan='3'>{detail?.TRMSPLCE} {detail?.TRMSPLTX}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id='bdtrms_damaged' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;4. 병원 전 정보</div>
                        <table summary='병원 전 정보'>
                            <colgroup>
                                <col width='15%' />
                                <col width='9%' />
                                <col width='9%' />
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>신고일시</th>
                                    <td colSpan={2}>{detail?.TRMSRPDTM}</td>
                                    <th className='not_sent'>119구급활동일지<br /> 일련번호</th>
                                    <td colspan='3'>{detail?.PTMIREID}</td>
                                </tr>
                                <tr>
                                    <th>현장도착일시</th>
                                    <td colSpan={2}>{detail?.TRMSARDTM}</td>
                                    <th>현장출발일시</th>
                                    <td>{detail?.TRMSPDDTM}</td>
                                    <th>현장체류시간</th>
                                    <td>{detail?.TRMSSYTM}</td>
                                </tr>
                                <tr>
                                    <th>초기현장 의식상태</th>
                                    <td colSpan={6}>
                                        {preslist.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmspres'
                                                    id={`trmspres${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSPRES === item.bscdminr}
                                                />
                                                <label htmlFor={`trmspres${index + 1}`}>{item.bscddesc}</label>
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                                <tr>
                                    <th>초기현장 활력징후</th>
                                    <td colspan='6' className='p-0'>
                                        <table summary='활력징후' className='v_inner_table' >
                                            <colgroup>
                                                <col width='10%' />
                                                <col width='23%' />
                                                <col width='10%' />
                                                <col width='23%' />
                                                <col width='10%' />
                                                <col width='24%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>수축기 혈압</th>
                                                    <td>{detail?.TRMSPSBP}</td>
                                                    <th>이완기 혈압</th>
                                                    <td>{detail?.TRMSPDBP}</td>
                                                    <th>맥박</th>
                                                    <td>{detail?.TRMSPPLS}</td>
                                                </tr>
                                                <tr>
                                                    <th>호흡</th>
                                                    <td>{detail?.TRMSPBRT}</td>
                                                    <th>체온</th>
                                                    <td>{detail?.TRMSPBDH}</td>
                                                    <th>산소포화도</th>
                                                    <td>{detail?.TRMSPOXS}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='not_sent'>초기현장 GCS</th>
                                    <td colspan='6' className='p-0'>
                                        <table summary='초기현장 GCS' className='v_inner_table' >
                                            <colgroup>
                                                <col width='10%' />
                                                <col width='23%' />
                                                <col width='10%' />
                                                <col width='23%' />
                                                <col width='10%' />
                                                <col width='24%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='not_sent'>눈</th>
                                                    <td>{detail?.TRMSPGCE}</td>
                                                    <th className='not_sent'>언어</th>
                                                    <td>{detail?.TRMSPGCV}</td>
                                                    <th className='not_sent'>언어(소아)</th>
                                                    <td>{detail?.TRMSPGCP}</td>
                                                </tr>
                                                <tr>
                                                    <th className='not_sent'>운동</th>
                                                    <td>{detail?.TRMSPGCM}</td>
                                                    <th className='not_sent'>전체</th>
                                                    <td colspan='3'>{detail?.TRMSPGCT}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowspan='10'>초기현장 <br />응급처치</th>
                                    <td></td>
                                    <td colSpan={5}>
                                        <input
                                            type='checkbox'
                                            name='trmspt01'
                                            id='trmspt01'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT01 === 'Y'}
                                        />
                                        <label htmlFor='trmspt01'>인공호흡</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt02'
                                            id='trmspt02'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT02 === 'Y'}
                                        />
                                        <label htmlFor='trmspt02'>과호흡처치</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt03'
                                            id='trmspt03'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT03 === 'Y'}
                                        />
                                        <label htmlFor='trmspt03'>ECG</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt04'
                                            id='trmspt04'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT04 === 'Y'}
                                        />
                                        <label htmlFor='trmspt04'>약물투여<span>({detail?.TRMSP04V})</span></label>
                                        <input
                                            type='checkbox'
                                            name='trmspt05'
                                            id='trmspt05'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT05 === 'Y'}
                                        />
                                        <label htmlFor='trmspt05'>분만</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt06'
                                            id='trmspt06'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT06 === 'Y'}
                                        />
                                        <label htmlFor='trmspt06'>기타({detail?.TRMSP06V})</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt09'
                                            id='trmspt09'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT09 === 'Y'}
                                        />
                                        <label htmlFor='trmspt09'>미상</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt99'
                                            id='trmspt99'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT99 === 'Y'}
                                        />
                                        <label htmlFor='trmspt99'>시행하지않음</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>기도확보</td>
                                    <td colSpan={5}>
                                        <input
                                            type='checkbox'
                                            name='trmspt11'
                                            id='trmspt11'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT11 === 'Y'}
                                        />
                                        <label htmlFor='trmspt11'>도수조작</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt12'
                                            id='trmspt12'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT12 === 'Y'}
                                        />
                                        <label htmlFor='trmspt12'>기도유지기</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt13'
                                            id='trmspt13'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT13 === 'Y'}
                                        />
                                        <label htmlFor='trmspt13'>후두마스크</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt14'
                                            id='trmspt14'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT14 === 'Y'}
                                        />
                                        <label htmlFor='trmspt14'>기도삽관</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt15'
                                            id='trmspt15'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT15 === 'Y'}
                                        />
                                        <label htmlFor='trmspt15'>흡인기</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt16'
                                            id='trmspt16'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT16 === 'Y'}
                                        />
                                        <label htmlFor='trmspt16'>기도폐쇄처치</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt17'
                                            id='trmspt17'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT17 === 'Y'}
                                        />
                                        <label htmlFor='trmspt17'>대체기관삽관</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>산소투여</p>
                                        <p className='not_sent px-1 w-fit'>({detail?.TRMSP20V} ℓ/min)</p>
                                    </td>
                                    <td colSpan={5}>
                                        <input
                                            type='checkbox'
                                            name='trmspt21'
                                            id='trmspt21'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT21 === 'Y'}
                                        />
                                        <label htmlFor='trmspt21'>비관</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt22'
                                            id='trmspt22'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT22 === 'Y'}
                                        />
                                        <label htmlFor='trmspt22'>안면마스크</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt23'
                                            id='trmspt23'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT23 === 'Y'}
                                        />
                                        <label htmlFor='trmspt23'>포켓마스크</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt24'
                                            id='trmspt24'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT24 === 'Y'}
                                        />
                                        <label htmlFor='trmspt24'>BVM</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt25'
                                            id='trmspt25'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT25 === 'Y'}
                                        />
                                        <label htmlFor='trmspt25'>산소소생기</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt26'
                                            id='trmspt26'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT26 === 'Y'}
                                        />
                                        <label htmlFor='trmspt26'>네뷸라이저</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt27'
                                            id='trmspt27'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT27 === 'Y'}
                                        />
                                        <label htmlFor='trmspt27'>기타</label>
                                        <input
                                            type='checkbox'
                                            name='trmspt28'
                                            id='trmspt28'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT28 === 'Y'}
                                        />
                                        <label htmlFor='trmspt28'>비재호흡마스크</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>CPR</td>
                                    <td colSpan={5}>
                                        <input type='checkbox' name='trmspt31' id='trmspt31' disabled value='Y' checked={detail?.TRMSPT31 === 'Y'} />
                                        <label htmlFor='trmspt31'>실시</label>
                                        <input type='checkbox' name='trmspt32' id='trmspt32' disabled value='Y' checked={detail?.TRMSPT32 === 'Y'} />
                                        <label htmlFor='trmspt32'>거부</label>
                                        <input type='checkbox' name='trmspt33' id='trmspt33' disabled value='Y' checked={detail?.TRMSPT33 === 'Y'} />
                                        <label htmlFor='trmspt33'>DNR</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>순환보조</td>
                                    <td colSpan={5}>
                                        <input type='checkbox' name='trmspt41' id='trmspt41' disabled value='Y' checked={detail?.TRMSPT41 === 'Y'} />
                                        <label htmlFor='trmspt41'>정맥로확보</label>
                                        <input type='checkbox' name='trmspt42' id='trmspt42' disabled value='Y' checked={detail?.TRMSPT42 === 'Y'} />
                                        <label htmlFor='trmspt42'>수액공급<span>({detail?.TRMSP42V} cc)확보</span></label>
                                        <input type='checkbox' name='trmspt43' id='trmspt43' disabled value='Y' checked={detail?.TRMSPT43 === 'Y'} />
                                        <label htmlFor='trmspt43'>MAST</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>고정</td>
                                    <td colSpan={5}>
                                        <input type='checkbox' name='trmspt51' id='trmspt51' disabled value='Y' checked={detail?.TRMSPT51 === 'Y'} />
                                        <label htmlFor='trmspt51'>경추</label>
                                        <input type='checkbox' name='trmspt52' id='trmspt52' disabled value='Y' checked={detail?.TRMSPT52 === 'Y'} />
                                        <label htmlFor='trmspt52'>척추</label>
                                        <input type='checkbox' name='trmspt53' id='trmspt53' disabled value='Y' checked={detail?.TRMSPT53 === 'Y'} />
                                        <label htmlFor='trmspt53'>부목</label>
                                        <input type='checkbox' name='trmspt54' id='trmspt54' disabled value='Y' checked={detail?.TRMSPT54 === 'Y'} />
                                        <label htmlFor='trmspt54'>머리</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>상처처치</td>
                                    <td colSpan={5}>
                                        <input type='checkbox' name='trmspt61' id='trmspt61' disabled value='Y' checked={detail?.TRMSPT61 === 'Y'} />
                                        <label htmlFor='trmspt61'>지혈</label>
                                        <input type='checkbox' name='trmspt62' id='trmspt62' disabled value='Y' checked={detail?.TRMSPT62 === 'Y'} />
                                        <label htmlFor='trmspt62'>상처드레싱</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>보온</td>
                                    <td colSpan={5}>
                                        <input type='checkbox' name='trmspt71' id='trmspt71' disabled value='Y' checked={detail?.TRMSPT71 === 'Y'} />
                                        <label htmlFor='trmspt71'>온</label>
                                        <input type='checkbox' name='trmspt72' id='trmspt72' disabled value='Y' checked={detail?.TRMSPT72 === 'Y'} />
                                        <label htmlFor='trmspt72'>냉</label>
                                    </td>
                                </tr>

                                <tr>
                                    <td>AED</td>
                                    <td colSpan={5}>
                                        <input type='checkbox' name='trmspt81' id='trmspt81' disabled value='Y' checked={detail?.TRMSPT81 === 'Y'} />
                                        <label htmlFor='trmspt81'>Shock</label>
                                        <input type='checkbox' name='trmspt82' id='trmspt82' disabled value='Y' checked={detail?.TRMSPT82 === 'Y'} />
                                        <label htmlFor='trmspt82'>Monitoring</label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id='bdtrms_sart' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;5. 기타정보</div>
                        <table summary='※ 기타정보'>
                            <colgroup>
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>전출 <br /> (transfer-out) <br /> 정보</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='전출(Transfer-out)' className='v_inner_table' >
                                            <colgroup>
                                                <col width='18%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='nedis'>전출 의료기관 종류</th>
                                                    <td>{detail?.PTMIDCTPDESC}</td>

                                                    <th>전출의료기관명</th>
                                                    <td>{detail?.TRMSTHGT}</td>
                                                    <th>전출 일시</th>
                                                    <td>{detail?.TRMSTHDTM}</td>
                                                </tr>
                                                <tr>
                                                    <th>전출 시 이송수단</th>
                                                    <td colspan='5'>{detail?.TRMSTHTR} {detail?.TRMSTHTX}</td>
                                                </tr>
                                                <tr>
                                                    <th>전출 시 동승인력</th>
                                                    <td colSpan={5}>
                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp1'
                                                            id='trmsthp1'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP1 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp1'>의사</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp2'
                                                            id='trmsthp2'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP2 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp2'>응급구조사</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp3'
                                                            id='trmsthp3'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP3 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp3'>간호사</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp4'
                                                            id='trmsthp4'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP4 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp4'>기타({detail?.TRMSTHPX})</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp5'
                                                            id='trmsthp5'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP5 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp5'>미상</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp6'
                                                            id='trmsthp6'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP6 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp6'>없음</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>전출 병원 연락유무</th>
                                                    <td>{detail?.TRMSTHCL}</td>
                                                    <th>전출 병원 기타내용</th>
                                                    <td colspan='3'>{detail?.TRMSTHCX}</td>
                                                </tr>
                                                <tr>
                                                    <th>전출 사유</th>
                                                    <td>{detail?.TRMSTHRS}</td>
                                                    <th>전출 사유 기타내용</th>
                                                    <td colspan='3'>{detail?.TRMSTHRX}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>사망 정보</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='사망 정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='18%' />
                                                <col width='82%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>사망선고일시</th>
                                                    <td>{detail?.TRMSDDDTM}</td>
                                                </tr>
                                                <tr>
                                                    <th>사망진단 정보</th>
                                                    <td colspan='3' className='p-0'>
                                                        <table summary='사망진단 정보' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>사망진단코드</th>
                                                                    <th>진단명</th>
                                                                    <th>Description</th>
                                                                    <th>사망진단구분</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emihdgdtlist && emihdgdtlist.length > 0 ? (
                                                                    emihdgdtlist.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.DGDTDIAG}</td>
                                                                            <td>{item.DIAGNAME}</td>
                                                                            <td>{item.DIAGDESC}</td>
                                                                            <td>{item.DGDTDGGB}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={5} className='text-center'>
                                                                            ※사망진단내역이 없습니다.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowspan='6'>최종 AIS</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='두경부' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colspan='4'>두경부</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist1 && emihaisilist1.length > 0 ? (
                                                    emihaisilist1.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan='6' className='p-0'>
                                        <table summary='안면' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colspan='4'>안면</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist2 && emihaisilist2.length > 0 ? (
                                                    emihaisilist2.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan='6' className='p-0'>
                                        <table summary='흉부' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colspan='4'>흉부</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist3 && emihaisilist3.length > 0 ? (
                                                    emihaisilist3.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan='6' className='p-0'>
                                        <table summary='복부 및 골반 내장기' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colspan='4'>복부 및 골반 내장기</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist4 && emihaisilist4.length > 0 ? (
                                                    emihaisilist4.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan='6' className='p-0'>
                                        <table summary='사지 및 골반' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colspan='4'>사지 및 골반</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist5 && emihaisilist5.length > 0 ? (
                                                    emihaisilist5.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan='6' className='p-0'>
                                        <table summary='외부' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colspan='4'>외부</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist6 && emihaisilist6.length > 0 ? (
                                                    emihaisilist6.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>최종 ISS</th>
                                    <td colspan='5'>{detail?.TRMSCISS}</td>
                                </tr>
                                {/* <tr className='border_not_sent'>
                                <th></th>
                                <td></td>
                                <th></th>
                                <td></td>
                                <th></th>
                                <td></td>
                            </tr> */}
                            </tbody>
                        </table>
                    </div>

                    <div className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;6. 추적관찰정보[미전송]</div>
                        <table summary='자. 추적관찰정보[미전송]'>
                            <colgroup>
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='not_sent'>추적관찰(6개월)<br />GOS</th>
                                    <td>{detail?.TRMSSAGO}</td>
                                    <th className='not_sent'>추적관찰(6개월)<br />사회복귀여부</th>
                                    <td>{detail?.TRMSSART}</td>
                                    <th className='not_sent'>추적관찰(6개월)<br />거주상태</th>
                                    <td>{detail?.TRMSSAHA}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='trms_v_wrapper'>
                    <div className='trms_v_section'>
                        <div className='trms_v_subject'>&nbsp;7. 외상센터 내원정보</div>
                        <table summary='외상센터 내원정보'>
                            <colgroup>
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='nedis'>내원일시</th>
                                    <td>{detail?.PTMIINDTM}</td>
                                    <th className='nedis'>내원경로</th>
                                    <td>{detail?.PTMIINRT}</td>
                                    <th className='nedis'>내원수단</th>
                                    <td>{detail?.PTMIINMN}</td>
                                </tr>
                                <tr>
                                    <th className='nedis'>보험유형</th>
                                    <td colspan='5'>{detail?.PTMIIUKD}</td>
                                </tr>
                                <tr>
                                    <th>전입(transfer-in) 정보</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='전입(transfer-in) 정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='nedis'>전입의료기관 종류</th>
                                                    <td>{detail?.TIEMDVNAME}</td>
                                                    <th>전입의료기관명</th>
                                                    <td>{detail?.TRMSFHGT}</td>
                                                </tr>
                                                <tr>
                                                    <th>전입의료기관<br /> 출발일시</th>
                                                    <td>{detail?.TRMSSTDTM}</td>
                                                    <th>전입시 동승인력</th>
                                                    <td>
                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp1'
                                                            id='trmsfhp1'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP1 === 'Y'}
                                                        />
                                                        <label htmlFor='trmsfhp1'>의사</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp2'
                                                            id='trmsfhp2'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP2 === 'Y'}
                                                        />
                                                        <label htmlFor='trmsfhp2'>응급구조사</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp3'
                                                            id='trmsfhp3'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP3 === 'Y'}
                                                        />
                                                        <label htmlFor='trmsfhp3'>간호사</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp4'
                                                            id='trmsfhp4'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP4 === 'Y'}
                                                        />
                                                        <label htmlFor='trmsfhp4'>기타 ({detail?.TRMSFHPX})</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp5'
                                                            id='trmsfhp5'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP5 === 'Y'}
                                                        />
                                                        <label htmlFor='trmsfhp5'>미상</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp6'
                                                            id='trmsfhp6'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP6 === 'Y'}
                                                        />
                                                        <label htmlFor='trmsfhp6'>없음</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>전입사유</th>
                                                    <td>{detail?.TRMSFHRS}</td>
                                                    <th>전입사유 <br />기타 텍스트</th>
                                                    <td>{detail?.TRMSFHRX}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>내원전</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='내원전' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>심정지유무</th>
                                                    <td>{detail?.TRMSARYN}</td>
                                                    <th>보고유무</th>
                                                    <td>{detail?.TRMSREYN}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>내원 시</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='내원 시' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='nedis'>의식상태</th>
                                                    <td colSpan={3}>
                                                        {resplist.map((item, index) => (
                                                            <React.Fragment key={item.bscdminr}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='ptmiresp'
                                                                    id={`ptmiresp${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.PTMIRESP === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`ptmiresp${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>호흡보조</th>
                                                    <td>
                                                        {vbralist.map((item, index) => (
                                                            <React.Fragment key={item.bscdminr}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='trmsvbra'
                                                                    id={`trmsvbra${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.TRMSVBRA === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`trmsvbra${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>

                                                    <th>산소보충</th>
                                                    <td>
                                                        {voxalist.map((item, index) => (
                                                            <React.Fragment key={item.bscdminr}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='trmsvoxa'
                                                                    id={`trmsvoxa${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.TRMSVOXA === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`trmsvoxa${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>활력징후</th>
                                                    <td colspan='3' className='p-0'>
                                                        <table summary='활력징후' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th className='nedis'>수축기 혈압</th>
                                                                    <td>{detail?.PTMIHIBP} mmhg</td>
                                                                    <th className='nedis'>이완기 혈압</th>
                                                                    <td>{detail?.PTMILOBP} mmhg</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className='nedis'>맥박</th>
                                                                    <td>{detail?.PTMIPULS} 회/min</td>
                                                                    <th className='nedis'>호흡</th>
                                                                    <td>{detail?.PTMIBRTH} 회/min</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className='nedis'>체온</th>
                                                                    <td>{detail?.PTMIBDHT} ℃</td>
                                                                    <th>산소포화도</th>
                                                                    <td>{detail?.TRMSVOXS} %</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>GCS 측정</th>
                                                    <td colspan='3' className='p-0'>
                                                        <table summary='GCS 측정' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th>sedative 여부</th>
                                                                    <td>{detail?.TRMSINGS}</td>
                                                                    <th>눈(eye)</th>
                                                                    <td>{detail?.TRMSVGCE}</td>

                                                                </tr>
                                                                <tr>
                                                                    <th>언어(verbal)</th>
                                                                    <td>{detail?.TRMSVGCV}</td>
                                                                    <th>언어(소아)</th>
                                                                    <td>{detail?.TRMSVGCP}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>운동(moter)</th>
                                                                    <td>{detail?.TRMSVGCM}</td>
                                                                    <th>GCS 점수(전체)</th>
                                                                    <td>{detail?.TRMSVGCT}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>RTS</th>
                                                    <td>{detail?.TRMSRTSC}</td>
                                                    <th>RTS_weighted</th>
                                                    <td>{detail?.TRMSRTSW}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>중증도<br />분류 정보</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='중증도 분류 정보' className='v_inner_table'>
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>최초 중증도<br />분류 일시</th>
                                                    <td>{detail?.PTMIKTDT}&nbsp;{detail?.PTMIKTTM}</td>
                                                    <th>최종진료구역</th>
                                                    <td>{detail?.PTMIAREADESC}</td>
                                                </tr>
                                                <tr>
                                                    <th>최초 중증도 <br />분류 과정</th>
                                                    <td>{detail?.PTMIKPR1} ({detail?.PTMIKPR1CD})</td>
                                                    <th>최초 중증도 <br />분류 결과</th>
                                                    <td>{detail?.PTMIKTS1DESC} ({detail?.PTMIKTS1})</td>
                                                </tr>
                                                <tr>
                                                    <th>최초 중증도<br /> 분류자 직종</th>
                                                    <td>{detail?.PTMIKJOBDESC}</td>
                                                    <th>최초 중증도 분류자 <br />면허 또는 자격번호</th>
                                                    <td>{detail?.PTMIKIDN}</td>
                                                </tr>
                                                <tr>
                                                    <th>변경된 중증도 <br />분류 과정</th>
                                                    <td>{detail?.PTMIKPR2} ({detail?.PTMIKPR2CD})</td>
                                                    <th>변경된 중증도 <br />분류 결과</th>
                                                    <td>{detail?.PTMIKTS2DESC} ({detail?.PTMIKTS2})</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id='bdtrms_diagnosis' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;8. 외상센터 진료정보</div>
                        <table summary='외상센터 진료정보'>
                            <colgroup>
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='nedis'>주증상</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='주증상' className='v_inner_table' >
                                            <colgroup>
                                                <col width='11%' />
                                                <col width='12%' />
                                                <col width='22%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>증상코드 1</th>
                                                    <td>{detail?.PTMIMNSY}</td>
                                                    <th>UMLS preferred term</th>
                                                    <td>{detail?.SYPTPRTM}</td>
                                                    <th>Chief complaint</th>
                                                    <td>{detail?.SYPTCHCO}</td>
                                                </tr>
                                                <tr>
                                                    <th>증상코드 2</th>
                                                    <td>{detail?.PTMISYM2}</td>
                                                    <th>UMLS preferred term</th>
                                                    <td>{detail?.SYPTPRTM2}</td>
                                                    <th>Chief complaint</th>
                                                    <td>{detail?.SYPTCHCO2}</td>
                                                </tr>
                                                <tr>
                                                    <th>증상코드 3</th>
                                                    <td>{detail?.PTMISYM3}</td>
                                                    <th>UMLS preferred term</th>
                                                    <td>{detail?.SYPTPRTM3}</td>
                                                    <th>Chief complaint</th>
                                                    <td>{detail?.SYPTCHCO3}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>알코올섭취</th>
                                    <td colspan='5'>{detail?.TRMSALYN}</td>
                                </tr>
                                <tr>
                                    <th>기저질환</th>
                                    <td colSpan={5}>
                                        <div className='flex flex-wrap gap-x-1'>
                                            {[
                                                { id: 'trmsbd11', label: 'MyocardialInfarction', key: 'TRMSBD11' },
                                                { id: 'trmsbd12', label: 'Congestive Heart Failure', key: 'TRMSBD12' },
                                                { id: 'trmsbd13', label: 'Peripheral Vascular Disease', key: 'TRMSBD13' },
                                                { id: 'trmsbd14', label: 'Cerebrovascular Disease', key: 'TRMSBD14' },
                                                { id: 'trmsbd15', label: 'Dementia', key: 'TRMSBD15' },
                                                { id: 'trmsbd16', label: 'COPD', key: 'TRMSBD16' },
                                                { id: 'trmsbd17', label: 'Connective Tissue Disease', key: 'TRMSBD17' },
                                                { id: 'trmsbd18', label: 'Peptic Ulcer Disease', key: 'TRMSBD18' },
                                                { id: 'trmsbd19', label: 'Diabetes Mellitus', key: 'TRMSBD19' },
                                                { id: 'trmsbd20', label: 'Moderate to Severe Chronic Kidney Disease', key: 'TRMSBD20' },
                                                { id: 'trmsbd21', label: 'Hemiplegia', key: 'TRMSBD21' },
                                                { id: 'trmsbd22', label: 'Leukemia', key: 'TRMSBD22' },
                                                { id: 'trmsbd23', label: 'Malignant Lymphoma', key: 'TRMSBD23' },
                                                { id: 'trmsbd24', label: 'Solid Tumor', key: 'TRMSBD24' },
                                                { id: 'trmsbd25', label: 'Liver Disease', key: 'TRMSBD25' },
                                                { id: 'trmsbd26', label: 'AIDS', key: 'TRMSBD26' },
                                                { id: 'trmsbd27', label: 'Bleeding disorder', key: 'TRMSBD27' },
                                                { id: 'trmsbd28', label: 'Angina', key: 'TRMSBD28' },
                                                { id: 'trmsbd29', label: 'Hypertension requiring medication', key: 'TRMSBD29' },
                                                { id: 'trmsbd30', label: 'Steroid use(Oral)', key: 'TRMSBD30' },
                                                { id: 'trmsbd99', label: '알수없음', key: 'TRMSBD99' },
                                                { id: 'trmsbd10', label: '기타( ' + detail?.TRMSBDTX + ' )', key: 'TRMSBD10' },
                                                { id: 'trmsbd09', label: '없음', key: 'TRMSBD09' },
                                            ].map(({ id, label, key }) => (
                                                <div key={id}>
                                                    <input
                                                        type='checkbox'
                                                        name={id}
                                                        id={id}
                                                        disabled
                                                        value='Y'
                                                        checked={detail[key] === 'Y'}
                                                        readOnly
                                                    />
                                                    <label htmlFor={id}>{label}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='nedis'>주진료과</th>
                                    <td colspan='5'>{detail?.PTMIDEPT}</td>
                                </tr>
                                <tr>
                                    <th>전문의</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='전문의' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='85%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>진료여부</th>
                                                    <td>{detail?.PTMISDCD}</td>
                                                </tr>
                                                <tr>
                                                    <th>전문의 진료내역</th>
                                                    <td className='p-0'>
                                                        <table summary='전문의' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>진료과목 코드</th>
                                                                    <th>진료과목 구분</th>
                                                                    <th>면허번호</th>
                                                                    <th>전문의 진료일시</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emihsdmdlist && emihsdmdlist.length > 0 ? (
                                                                    emihsdmdlist.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.SDMDDEPT}</td>
                                                                            <td>{item.SDMDDIVI}</td>
                                                                            <td>{item.SDMDDRLC}</td>
                                                                            <td>{item.SDMDSDDTM}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={4} className='text-center'>
                                                                            ※ 진료내역이 없습니다.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>외상팀</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='외상팀' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>호출여부</th>
                                                    <td>{detail?.TRMSCLYN}</td>
                                                    <th>호출일시</th>
                                                    <td>{detail?.TRMSCLDTM}</td>
                                                </tr>
                                                <tr>
                                                    <th>활성화 정보</th>
                                                    <td colspan='3' className='p-0'>
                                                        <table summary='활성화 정보' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='20%' />
                                                                <col width='20%' />
                                                                <col width='20%' />
                                                                <col width='20%' />
                                                                <col width='20%' />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>도착일시</th>
                                                                    <th>면허번호</th>
                                                                    <th>성명</th>
                                                                    <th>진료과</th>
                                                                    <th>전담여부</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emihcltplist && emihcltplist.length > 0 ? (
                                                                    emihcltplist.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.CLTPTEDTM}</td>
                                                                            <td>{item.CLTPTENO}</td>
                                                                            <td>{item.CLTPTENM}</td>
                                                                            <td>{item.CLTPDEPT}</td>
                                                                            <td>{item.CLTPDDCT}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={5} className='text-center'>
                                                                            ※ 활성화내역이 없습니다.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>최저혈압</th>
                                    <td colSpan={2}>SBP : {detail?.TRMSLSBP} mmhg DBP : {detail?.TRMSLDBP} mmhg</td>
                                    <th>평균 동맥압(MAP)</th>
                                    <td colSpan={3}>{detail?.TRMSTMAP} mmhg <span>( MAP = DBP+(SBP-DBP)/3 )</span></td>
                                </tr>
                                <tr>
                                    <th>퇴실시 GCS</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='퇴실시 GCS' className='v_inner_table' >
                                            <colgroup>
                                                <col width='10%' />
                                                <col width='23%' />
                                                <col width='10%' />
                                                <col width='23%' />
                                                <col width='10%' />
                                                <col width='23%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>sedative<br />여부</th>
                                                    <td>{detail?.TRMSOTGS}</td>
                                                    <th>눈</th>
                                                    <td>{detail?.TRMSOGCE}</td>
                                                    <th>언어</th>
                                                    <td>{detail?.TRMSOGCV}</td>

                                                </tr>
                                                <tr>
                                                    <th>언어(소아)</th>
                                                    <td>{detail?.TRMSOGCP}</td>
                                                    <th>운동</th>
                                                    <td>{detail?.TRMSOGCM}</td>
                                                    <th>전체</th>
                                                    <td>{detail?.TRMSOGCT}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>퇴실정보</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='퇴실정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='nedis'>퇴실일시</th>
                                                    <td>{detail?.PTMIOTDTM}</td>
                                                    <th className='nedis'>응급실진료결과</th>
                                                    <td>{detail?.PTMIEMRT}</td>
                                                </tr>
                                                <tr>
                                                    <th className='nedis'>퇴실 진단정보</th>
                                                    <td colspan='3' className='p-0'>
                                                        <table summary='퇴실 진단정보' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='20%' />
                                                                <col width='30%' />
                                                                <col width='30%' />
                                                                <col width='20%' />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>퇴실진단코드</th>
                                                                    <th>진단명</th>
                                                                    <th>Description</th>
                                                                    <th>퇴실진단구분</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emihdgotlist && emihdgotlist.length > 0 ? (
                                                                    emihdgotlist.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.DGOTDIAG}</td>
                                                                            <td>{item.DIAGNAME}</td>
                                                                            <td>{item.DIAGDESC}</td>
                                                                            <td>{item.DGOTDGGB}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={4} className='text-center'>
                                                                            ※ 퇴실진단내역이 없습니다.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>입원장 발부일시</th>
                                    <td>{detail?.TRMSATDTM}</td>
                                    <th>입원장발부 소요시간</th>
                                    <td>{detail?.TRMSATTT}</td>
                                    <th>입원경로</th>
                                    <td>{detail?.PTMIHSRT}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div id='bdtrms_treatment' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;9. 환자검사 및 치료정보</div>
                        <table summary='사. 환자검사 및 치료정보'>
                            <colgroup>
                                <col width='10%' />
                                <col width='23%' />
                                <col width='10%' />
                                <col width='23%' />
                                <col width='10%' />
                                <col width='24%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>영상검사</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='영상검사' className='v_inner_table' >
                                            <colgroup>
                                                <col width='20%' />
                                                <col width='20%' />
                                                <col width='20%' />
                                                <col width='20%' />
                                                <col width='20%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>종류</th>
                                                    <th>기타 내용</th>
                                                    <th>시행일시</th>
                                                    <th>판독결과보고일시</th>
                                                    <th>판독결과</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihtrhtlist1 && emihtrhtlist1.length > 0 ? (
                                                    emihtrhtlist1.map((item, index) => {
                                                        if (item.TRHTVALU === '99') {
                                                            // '99'일 때는 '실시안함' 행 하나만 출력
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={5} className='text-center'>
                                                                        실시안함
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            // '99'가 아닌 경우는 데이터 출력
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{item.TRHTVALU}</td>
                                                                    <td>{item.TRHTNMTX}</td>
                                                                    <td>{item.TRHTEXDTM}</td>
                                                                    <td>{item.TRHTEDDTM}</td>
                                                                    <td>{item.TRHTRDRT}</td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={5} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>수술(시술)</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='수술(시술)' className='v_inner_table' >
                                            <colgroup>
                                                <col width='20%' />
                                                <col width='20%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>입실일시</th>
                                                    <th>시행일시</th>
                                                    <th>수술(시술)코드</th>
                                                    <th>수술(시술)명</th>
                                                    <th>시행의사 성명</th>
                                                    <th>시행의사 면허번호</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihtrhtlist2 && emihtrhtlist2.length > 0 ? (
                                                    emihtrhtlist2.map((item, index) => {
                                                        if (item.TRHTVALU === '99') {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={6} className='text-center'>
                                                                        실시안함
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{item.TRHTOPDTM}</td>
                                                                    <td>{item.TRHTEXDTM}</td>
                                                                    <td>{item.TRHTVALU}</td>
                                                                    <td>{item.TRCDDESC}</td>
                                                                    <td>{item.TRHTDONM}</td>
                                                                    <td>{item.TRHTDONO}</td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>인공호흡기</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='인공호흡기' className='v_inner_table' >
                                            <colgroup>
                                                <col width='50%' />
                                                <col width='50%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>부착기간(분)</th>
                                                    <td colspan='3'>{detail?.TRMSRSPR}</td>
                                                </tr>
                                                <tr>
                                                    <th>부착일시</th>
                                                    <th>제거일시</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihtrhtlist4 && emihtrhtlist4.length > 0 ? (
                                                    emihtrhtlist4.map((item, index) => {
                                                        if (item.TRHTVALU === '99') {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={2} className='text-center'>
                                                                        실시안함
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{item.TRHTEXDTM}</td>
                                                                    <td>{item.TRHTEDDTM}</td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={2} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>최저혈압 및 수혈정보</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='최저혈압 및 수혈정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='85%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>최초 수혈시작일시</th>
                                                    <td>{detail?.TRMSTRDTM}</td>
                                                </tr>
                                                <tr>
                                                    <th>내원4시간 내 수혈량</th>
                                                    <td colspan='3' className='p-0'>
                                                        <table summary='내원4시간 내 수혈량' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th>적혈구(RBC)</th>
                                                                    <td>{detail?.TRMSITR1} pack</td>
                                                                    <th>혈장(plasma)</th>
                                                                    <td>{detail?.TRMSITR2} pack</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>혈소판(platelet)</th>
                                                                    <td>{detail?.TRMSITR3} pack</td>
                                                                    <th>전혈(whole blood)</th>
                                                                    <td>{detail?.TRMSITR4} pack</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>내원24시간 내 추가 수혈량</th>
                                                    <td colspan='3' className='p-0'>
                                                        <table summary='내원24시간 내 추가 수혈량' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th>적혈구(RBC)</th>
                                                                    <td>{detail?.TRMSOTR1} pack</td>
                                                                    <th>혈장(plasma)</th>
                                                                    <td>{detail?.TRMSOTR2} pack</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>혈소판(platelet)</th>
                                                                    <td>{detail?.TRMSOTR3} pack</td>
                                                                    <th>전혈(whole blood)</th>
                                                                    <td>{detail?.TRMSOTR4} pack</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div id='bdtrms_medical' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>10. 입원 후 진료정보와 결과 정보</div>
                        <table summary='아. 입원 후 진료정보와 결과 정보'>
                            <colgroup>
                                <col width='10%' />
                                <col width='23%' />
                                <col width='10%' />
                                <col width='23%' />
                                <col width='10%' />
                                <col width='24%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>중환자실 입실/퇴실일시</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='중환자실 입실/퇴실일시' className='v_inner_table' >
                                            <colgroup>
                                                <col width='50%' />
                                                <col width='50%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>중환자실 입원기간</th>
                                                    <td>{detail?.TRMSVTPR}</td>
                                                </tr>
                                                <tr>
                                                    <th>입실일시</th>
                                                    <th>퇴실일시</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihtrhtlist3 && emihtrhtlist3.length > 0 ? (
                                                    emihtrhtlist3.map((item, index) => {
                                                        if (item.TRHTVALU === '99') {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={2} className='text-center'>
                                                                        실시안함
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{item.TRHTEXDTM}</td>
                                                                    <td>{item.TRHTEDDTM}</td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={2} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>합병증 <br />(복수선택가능)</th>
                                    <td colSpan={5}>
                                        <div className='flex flex-wrap gap-x-1'>
                                            {[
                                                { id: 'trmscp01', label: '의료적합병증없음', key: 'TRMSCP01' },
                                                { id: 'trmscp02', label: '급성신부전', key: 'TRMSCP02' },
                                                { id: 'trmscp03', label: '급성호흡곤란증후군', key: 'TRMSCP03' },
                                                { id: 'trmscp04', label: '심폐소생술을시행한심정지', key: 'TRMSCP04' },
                                                { id: 'trmscp05', label: '욕창', key: 'TRMSCP05' },
                                                { id: 'trmscp06', label: '깊은수술부위감염', key: 'TRMSCP06' },
                                                { id: 'trmscp07', label: '약물또는알코올금단증후군', key: 'TRMSCP07' },
                                                { id: 'trmscp08', label: '심부정맥혈전증_혈전정맥염', key: 'TRMSCP08' },
                                                { id: 'trmscp09', label: '팔다리구획증후군', key: 'TRMSCP09' },
                                                { id: 'trmscp10', label: '이식,의치,피판수술실패', key: 'TRMSCP10' },
                                                { id: 'trmscp11', label: '심근경색증', key: 'TRMSCP11' },
                                                { id: 'trmscp12', label: '장기수술부위감염', key: 'TRMSCP12' },
                                                { id: 'trmscp13', label: '폐렴', key: 'TRMSCP13' },
                                                { id: 'trmscp14', label: '폐색전증', key: 'TRMSCP14' },
                                                { id: 'trmscp15', label: '뇌졸중', key: 'TRMSCP15' },
                                                { id: 'trmscp16', label: '표면적수술부위감염', key: 'TRMSCP16' },
                                                { id: 'trmscp17', label: '계획에 없던기관삽관', key: 'TRMSCP17' },
                                                { id: 'trmscp18', label: '요로감염', key: 'TRMSCP18' },
                                                { id: 'trmscp19', label: 'catheter-related blood stream Infection', key: 'TRMSCP19' },
                                                { id: 'trmscp20', label: '골수염', key: 'TRMSCP20' },
                                                { id: 'trmscp21', label: 'unplanned return to the OR', key: 'TRMSCP21' },
                                                { id: 'trmscp22', label: 'unplanned return to the ICU', key: 'TRMSCP22' },
                                                { id: 'trmscp23', label: 'severe sepsis', key: 'TRMSCP23' },
                                            ].map(({ id, label, key }) => (
                                                <div key={id}>
                                                    <input
                                                        type='checkbox'
                                                        name={id}
                                                        id={id}
                                                        disabled
                                                        value='Y'
                                                        checked={detail[key] === 'Y'}
                                                        readOnly
                                                    />
                                                    <label htmlFor={id}>{label}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='nedis'>입원 후 결과</th>
                                    <td colspan='5'>{detail?.PTMIDCRT}</td>
                                </tr>
                                <tr>
                                    <th>퇴원정보</th>
                                    <td colspan='5' className='p-0'>
                                        <table summary='퇴원정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='nedis'>퇴원일시</th>
                                                    <td>{detail?.PTMIDCDTM}</td>
                                                    <th>퇴원 시 GOS</th>
                                                    <td>{detail?.TRMSTGOS}</td>
                                                </tr>
                                                <tr>
                                                    <th className='nedis'>퇴원진단 정보</th>
                                                    <td colspan='3' className='p-0'>
                                                        <table summary='퇴원진단 정보' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='20%' />
                                                                <col width='30%' />
                                                                <col width='30%' />
                                                                <col width='20%' />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>퇴원진단코드</th>
                                                                    <th>진단명</th>
                                                                    <th>Description</th>
                                                                    <th>퇴원진단구분</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emihdgdclist && emihdgdclist.length > 0 ? (
                                                                    emihdgdclist.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.DGDCDIAG}</td>
                                                                            <td>{item.DIAGNAME}</td>
                                                                            <td>{item.DIAGDESC}</td>
                                                                            <td>{item.DGDCDGGB}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={4} className='text-center'>
                                                                            ※퇴원진단내역이 없습니다.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default TrmsV2_popup;